import NewDataConfirmation from './component';

export default NewDataConfirmation;
